import { Segment } from './types'

export const getCaretPosition = (el: HTMLElement): number => {
  const selection = window.getSelection()
  if (!selection || selection.rangeCount === 0) return 0
  const range = selection.getRangeAt(0)
  if (range.commonAncestorContainer.parentNode === el) {
    return range.startOffset
  }
  return 0
}

export const setCaretPosition = (el: HTMLElement, position: number | 'start' | 'end') => {
  const selection = window.getSelection()
  const range = document.createRange()
  const textNode = el.firstChild
  if (!textNode || !selection) return

  let offset: number
  if (position === 'start') {
    offset = 0
  } else if (position === 'end') {
    offset = textNode.textContent?.length || 0
  } else {
    offset = position
  }

  offset = Math.max(0, Math.min(offset, textNode.textContent?.length || 0))

  range.setStart(textNode, offset)
  range.collapse(true)
  selection.removeAllRanges()
  selection.addRange(range)
}

export const setCaretByGlobalPosition = (
  globalPos: number,
  segments: Segment[],
  elRefs: React.RefObject<Map<string, HTMLSpanElement>>,
) => {
  let cumulativeLength = 0
  for (const segment of segments) {
    const segmentLength = segment.content.length
    if (globalPos <= cumulativeLength + segmentLength) {
      const relativePos = globalPos - cumulativeLength
      const el = elRefs.current?.get(segment.id)
      if (el) {
        setCaretPosition(el, relativePos)
      }
      return
    }
    cumulativeLength += segmentLength
  }
} 